/*
 * Wishlist (localStorage, no backend).
 * - Heart buttons [data-wishlist-handle] (rendered by snippets/wishlist-heart.liquid)
 *   toggle the saved state; state is synced across all cards on the page.
 * - <wishlist-products> renders the saved list on the Merkliste page
 *   (same minimal-card pattern as recently-viewed.js).
 */
(function () {
  const STORAGE_KEY = 'kegret-wishlist';
  const MAX_ITEMS = 50;

  function readList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* storage full / private mode: ignore */
    }
  }

  function isSaved(handle) {
    return readList().some((item) => item.handle === handle);
  }

  /* Header 心形图标的数量气泡 (id=wishlist-count-bubble, 0 时隐藏) */
  function updateBubble() {
    const bubble = document.getElementById('wishlist-count-bubble');
    if (!bubble) return;
    const count = readList().length;
    bubble.textContent = count < 100 ? String(count) : '99+';
    bubble.hidden = count === 0;
  }

  function itemFromButton(btn) {
    return {
      handle: btn.dataset.wishlistHandle,
      title: btn.dataset.wishlistTitle || '',
      url: btn.dataset.wishlistUrl || '/products/' + btn.dataset.wishlistHandle,
      image: btn.dataset.wishlistImage || '',
      price: btn.dataset.wishlistPrice || ''
    };
  }

  function toggle(item) {
    const list = readList();
    const index = list.findIndex((i) => i.handle === item.handle);
    const nowSaved = index === -1;
    if (nowSaved) list.unshift(item);
    else list.splice(index, 1);
    writeList(list);
    return nowSaved;
  }

  function syncHearts(root) {
    (root || document).querySelectorAll('[data-wishlist-handle]').forEach((btn) => {
      const saved = isSaved(btn.dataset.wishlistHandle);
      btn.classList.toggle('wishlist-heart--saved', saved);
      btn.setAttribute('aria-pressed', String(saved));
    });
    updateBubble();
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(itemFromButton(btn));
    syncHearts(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncHearts(document));
  } else {
    syncHearts(document);
  }

  class WishlistProducts extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    render() {
      const items = readList();
      const list = this.querySelector('[data-wishlist-list]');
      const empty = this.querySelector('[data-wishlist-empty]');
      if (!list) return;
      list.innerHTML = '';
      if (empty) empty.hidden = items.length > 0;
      if (items.length === 0) return;

      const removeText = this.dataset.removeText || 'Entfernen';
      items.forEach((item) => {
        const li = document.createElement('li');
        li.className = 'wishlist__item';
        li.innerHTML = `
          <a href="${item.url}" class="wishlist__card full-unstyled-link">
            ${item.image ? `<span class="wishlist__media"><img src="${item.image}" alt="" width="300" height="300" loading="lazy" class="wishlist__image"></span>` : ''}
            <span class="wishlist__title"></span>
            <span class="wishlist__price"></span>
          </a>
          <button type="button" class="wishlist__remove link"></button>`;
        li.querySelector('.wishlist__title').textContent = item.title;
        li.querySelector('.wishlist__price').textContent = item.price;
        li.querySelector('.wishlist__remove').textContent = removeText;
        li.querySelector('.wishlist__remove').addEventListener('click', () => {
          toggle(item);
          this.render();
          syncHearts(document);
        });
        list.appendChild(li);
      });
    }
  }

  customElements.define('wishlist-products', WishlistProducts);
})();
